<script>import { getCtx, getAttrs } from "../ctx.js";
export let asChild = false;
const {
  helpers: { isChecked, isIndeterminate },
  states: { checked }
} = getCtx();
function getStateAttr(state) {
  if (state === "indeterminate")
    return "indeterminate";
  if (state)
    return "checked";
  return "unchecked";
}
$:
  attrs = {
    ...getAttrs("indicator"),
    "data-state": getStateAttr($checked)
  };
</script>

{#if asChild}
	<slot {attrs} isChecked={$isChecked} isIndeterminate={$isIndeterminate} />
{:else}
	<div {...$$restProps} {...attrs}>
		<slot {attrs} isChecked={$isChecked} isIndeterminate={$isIndeterminate} />
	</div>
{/if}
